var exports = {
  "jw": "MessageThreadChip.module__chip___WlFXVk",
  "nM": "MessageThreadChip.module__row___WlFXVk",
  "UU": "MessageThreadChip.module__name___WlFXVk",
  "U9": "MessageThreadChip.module__count___WlFXVk",
  "VH": "MessageThreadChip.module__preview___WlFXVk",
};

module.exports = exports;
